// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1SQtt","dragIcon":"Choice_dragIcon__3-Y2m","left":"Choice_left__2P6_O","input":"Choice_input__3PwsV"};